// extracted by mini-css-extract-plugin
export default {"circleContainer":"circlegroup_circleContainer__qbNDV","circleIcon":"circlegroup_circleIcon__rc7ei"};